/**
 * Bonus stage list
 */
export enum BonusStage {
  HANDLE_BETS = 'handle_bets',
  LOST = 'lost',
  CANCELED = 'canceled',
  PLAYED = 'played',
  ISSUED = 'issued',
  EXPIRED = 'expired',
  WAGER_DONE = 'wager_done',
  ACTIVATED = 'activated',
  FINISHED = 'finished',
  UNUSED = 'unused', // this stage was added in DEVBIT-1201 task for display unused bonuses in notification center
  VALENTINE_FS = 'valentine_fs',
  BONUSES_FOR_DISPLAY = 'bonusesForDisplay', // bonuses to display at bonus and account page
  LAST_RECEIVED_DEPOSIT = 'lastReceivedDeposit',
  VIP = 'vip',
}

/**
 * Available histories
 */
export enum BonusType {
  MONEY = 'money',
  FREE_SPINS = 'free_spins',
  LOOTBOX = 'lootboxes',
  DEPOSIT = 'deposit',
}

/**
 * Text labels for bonus stages
 */
export const BonusStageLabel = {
  [BonusStage.HANDLE_BETS]: 't.handle-bets',
  [BonusStage.LOST]: 't.lost',
  [BonusStage.CANCELED]: 't.canceled',
  [BonusStage.PLAYED]: 't.played',
  [BonusStage.ISSUED]: 't.issued',
  [BonusStage.EXPIRED]: 't.expired',
  [BonusStage.WAGER_DONE]: 't.wager-done',
  [BonusStage.ACTIVATED]: 't.activated',
  [BonusStage.FINISHED]: 't.finished',
};
